import axiosInstance from '@/lib/enhancedAxiosInstance';

// Types for attribute insights API responses
export interface AttributeAdoption {
  attribute_id: number;
  attribute_label: string;
  attribute_code: string;
  attribute_data_type: string;
  adoption_pct: string;
  filled_count: number;
  total_count: number;
  trend_direction: 'up' | 'down' | 'stable';
  trend_change_pct: string;
  avg_value_length: number;
  unique_values_count: number;
}

export interface AttributeAdoptionResponse {
  results: AttributeAdoption[];
  snapshot_date: string;
  total_attributes: number;
  filters_applied: {
    trend?: string;
    data_type?: string;
    top: number;
  };
}

export interface AttributeAdoptionFilters {
  top?: number;
  trend?: string;
  data_type?: string;
}

/**
 * Fetch attribute adoption analytics
 */
export const fetchAttributeAdoption = async (
  filters: AttributeAdoptionFilters = {}
): Promise<AttributeAdoptionResponse> => {
  const params = new URLSearchParams();

  if (filters.top) params.append('top', filters.top.toString());
  if (filters.trend) params.append('trend', filters.trend);
  if (filters.data_type) params.append('data_type', filters.data_type);

  const response = await axiosInstance.get(`/api/analytics/attribute-adoption/?${params}`);
  return response.data;
};

/**
 * Export attribute adoption data
 */
export const exportAttributeAdoption = async (
  filters: AttributeAdoptionFilters = {}
): Promise<Blob> => {
  const params = new URLSearchParams();

  // Add filters
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value.toString());
    }
  });

  params.append('format', 'xlsx');

  const response = await axiosInstance.get(`/api/analytics/attribute-adoption/export/?${params}`, {
    responseType: 'blob',
  });

  return response.data;
};
